var _path, _rect, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLandShip = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m29.59,39.57h4.83l1.12-2.04h6.06l-8.29-28.59h-2.62l-8.29,28.59h6.06l1.12,2.04Zm1.77-13.38h1.29l2.83,9.16h-6.96l2.83-9.16Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 30.84,
  y: 43.7,
  width: 2.32,
  height: 6.15
})), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "43.25 44.35 39.16 52.74 32.35 52.74 24.28 52.74 20.19 44.35 11.92 44.35 11.92 46.67 18.74 46.67 22.83 55.06 32.35 55.06 40.61 55.06 44.7 46.67 52.77 46.67 52.77 44.35 43.25 44.35"
})), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
  points: "28.23 40.55 24.52 43.6 28.23 49.7 28.23 40.55"
})), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
  points: "35.48 49.7 39.19 43.6 35.48 40.55 35.48 49.7"
})));
export default SvgLandShip;